/**
 * Fades and lifts each top-level section into place the first time it scrolls
 * into view, for a more polished feel than everything just snapping in.
 * Skips the first section (the hero) since it's already visible on load.
 */
const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const inThemeEditor = window.Shopify?.designMode === true;

if (!prefersReducedMotion && !inThemeEditor && 'IntersectionObserver' in window) {
  const mainContent = document.getElementById('MainContent');
  const sections = mainContent ? Array.from(mainContent.querySelectorAll(':scope > .shopify-section')) : [];
  const targets = sections.slice(1);

  if (targets.length > 0) {
    const duration = 700;
    const easing = 'cubic-bezier(0.16, 1, 0.3, 1)';
    const distance = 28;

    targets.forEach((section) => {
      section.style.opacity = '0';
      section.style.transform = `translateY(${distance}px)`;
      section.style.transition = `opacity ${duration}ms ${easing}, transform ${duration}ms ${easing}`;
      section.style.willChange = 'opacity, transform';
    });

    const observer = new IntersectionObserver(
      (entries, obs) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;

          const target = entry.target;
          target.style.opacity = '1';
          target.style.transform = 'translateY(0)';
          obs.unobserve(target);
        }
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
    );

    targets.forEach((section) => observer.observe(section));
  }
}
